import * as React from 'react';
import { widgetContext } from '../../context/widgetContext';
import { Menu } from '../../components/Menu';
import { trackMenuItemClick } from '../../analytics';
import { jsx as _jsx } from "react/jsx-runtime";
export var MenuContainer = function MenuContainer(props) {
  var _props$activeIndex = props.activeIndex,
      activeIndex = _props$activeIndex === void 0 ? 3 : _props$activeIndex;

  var _React$useContext = React.useContext(widgetContext),
      targetPage = _React$useContext.targetPage,
      isWebview = _React$useContext.isWebview;

  var handleClick = React.useCallback(function (e, index, menuItem) {
    if (activeIndex === index) {
      e.preventDefault();
      return;
    }

    trackMenuItemClick(targetPage, menuItem);
  }, [activeIndex, targetPage]);

  if (isWebview) {
    return null;
  }

  return /*#__PURE__*/_jsx(Menu, {
    activeIndex: activeIndex,
    onClick: handleClick
  });
};